/* eslint-disable indent */
import { EMPTY_HTML_TAG_REGEX } from './regex.utils';

export type ParseEmailsProps = {
  inputEmails: string | string[] | null | undefined;
  excludeEmails?: (string | null | undefined)[];
};

export const getPluralString = (
  singularString: string,
  numberOfOccurrences: number,
) => `${singularString}${numberOfOccurrences > 1 ? 's' : ''}`;

export const generateObjectId = () => {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
  const randomBytes = 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () =>
    ((Math.random() * 16) | 0).toString(16),
  );
  return timestamp + randomBytes;
};

export const containsOnlyEmptyHTMLTags = (input: string) => {
  // Remove all empty HTML tags from the input string
  const strippedString = input.replace(EMPTY_HTML_TAG_REGEX, '').trim();
  return strippedString === '';
};

export const getChangedStringPlaceholder = (template: string, data: object) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    return data[key] !== undefined ? data[key] : `{{${key}}}`;
  });
};

/**
 * Split the textarea content into a clean array of email addresses.
 * Accepts "," or ";" as separators. Optionally drops any email matching
 * one of `exclude` (case-insensitive, trimmed) — useful to avoid
 * duplicating the primary recipient in a cc list.
 */
export const parseEmails = ({
  inputEmails,
  excludeEmails,
}: ParseEmailsProps): string[] => {
  if (!inputEmails) return [];
  const sanitized = Array.isArray(inputEmails)
    ? inputEmails
    : inputEmails
        .replace(/[^a-zA-Z0-9]+$/, '')
        .split(/[,;]/)
        .map((email) => email?.trim());
  const cleaned = sanitized?.filter(Boolean);

  if (!excludeEmails?.length) return cleaned;
  const blocklist = new Set(
    excludeEmails
      ?.filter((value): value is string => Boolean(value))
      ?.map((value) => value?.trim()?.toLowerCase()),
  );
  return cleaned.filter(
    (email) => !blocklist.has(email?.trim()?.toLowerCase()),
  );
};
